import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-entire-word',
  templateUrl: './pdf-find-entire-word.component.html',
  styleUrls: ['./pdf-find-entire-word.component.css'],
})
export class PdfFindEntireWordComponent {}
